declare const grecaptcha: {
  ready: (cb: () => void) => void;
  execute: (key: string, opts: { action: string }) => Promise<string>;
};

const RECAPTCHA_TIMEOUT_MS = 10000;

/**
 * Resolve a reCAPTCHA v3 token for the "submit" action. The script is loaded
 * once at the app root (see routes.tsx), so `grecaptcha` is available globally.
 */
export const getRecaptchaToken = (): Promise<string> =>
  new Promise((resolve, reject) => {
    if (typeof grecaptcha === "undefined") {
      reject(new Error("reCAPTCHA is not loaded yet"));
      return;
    }

    let isSettled = false;
    const timeoutId = setTimeout(() => {
      if (isSettled) return;
      isSettled = true;
      reject(new Error("reCAPTCHA timed out"));
    }, RECAPTCHA_TIMEOUT_MS);

    const settle =
      <T>(handler: (value: T) => void) =>
      (value: T) => {
        if (isSettled) return;
        isSettled = true;
        clearTimeout(timeoutId);
        handler(value);
      };

    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.PUBLIC_RECAPTCHA_KEY as string, {
          action: "submit",
        })
        .then(settle(resolve))
        .catch(settle(reject));
    });
  });
